module.exports = __webpack_public_path__ + "static/media/map_skew.e88c3619.png";